 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activePlayerList~adminAccess~adsimages~agentcommission~cards~cardspergame~cashin~cashinreport~cashou~51ae20eb":"activePlayerList~adminAccess~adsimages~agentcommission~cards~cardspergame~cashin~cashinreport~cashou~51ae20eb","activePlayerList~adsimages~agentcommission~cards~cashin~cashinreport~cashout~cashoutreport~commissio~7cf5bb2f":"activePlayerList~adsimages~agentcommission~cards~cashin~cashinreport~cashout~cashoutreport~commissio~7cf5bb2f","activePlayerList":"activePlayerList","adsimages~endinggamereport~transactionalreport":"adsimages~endinggamereport~transactionalreport","adsimages~newsAndUpdates":"adsimages~newsAndUpdates","adsimages":"adsimages","transactionalreport":"transactionalreport","agentcommission":"agentcommission","cards":"cards","cashin":"cashin","cashinreport":"cashinreport","cashout":"cashout","cashoutreport":"cashoutreport","commission_payments":"commission_payments","dashboard~playerdetails":"dashboard~playerdetails","playerdetails":"playerdetails","dashboard~playerlist~playerlistduplicates~specialcommissions~summary_report":"dashboard~playerlist~playerlistduplicates~specialcommissions~summary_report","dashboard":"dashboard","playerlist":"playerlist","specialcommissions":"specialcommissions","endingbets":"endingbets","endingcards":"endingcards","endinggamedetails~endingscheduledgames":"endinggamedetails~endingscheduledgames","endinggamedetails":"endinggamedetails","endingscheduledgames":"endingscheduledgames","endinggamereport~endingprogressreport~luckyFourGameReport":"endinggamereport~endingprogressreport~luckyFourGameReport","endinggamereport":"endinggamereport","endingprogressreport":"endingprogressreport","luckyFourGameReport":"luckyFourGameReport","investors":"investors","leaguesbet":"leaguesbet","luckyFourBets":"luckyFourBets","luckyFourGames":"luckyFourGames","newPlayerList":"newPlayerList","player_withdrawal_accounts":"player_withdrawal_accounts","players":"players","powerBallBets":"powerBallBets","powerBallScheduledGames":"powerBallScheduledGames","registeredplayerlist":"registeredplayerlist","top_winning_combination":"top_winning_combination","users":"users","adminAccess":"adminAccess","newsAndUpdates":"newsAndUpdates","cardspergame":"cardspergame","playerlistduplicates":"playerlistduplicates","summary_report":"summary_report","endingconfig":"endingconfig","endingleagues":"endingleagues","endingteams":"endingteams","luckyFourGameDetails":"luckyFourGameDetails","luckyFourPrizesSettings":"luckyFourPrizesSettings","master_agents_token":"master_agents_token","playerRejectReasons":"playerRejectReasons","powerBallGameDetails":"powerBallGameDetails","sms":"sms","endingcarddetails":"endingcarddetails","login_verification":"login_verification","pagenotfound":"pagenotfound"}[chunkId]||chunkId) + "." + {"activePlayerList~adminAccess~adsimages~agentcommission~cards~cardspergame~cashin~cashinreport~cashou~51ae20eb":"a8da7b69","activePlayerList~adsimages~agentcommission~cards~cashin~cashinreport~cashout~cashoutreport~commissio~7cf5bb2f":"a7985ceb","activePlayerList":"3fbe4843","adsimages~endinggamereport~transactionalreport":"574613d0","adsimages~newsAndUpdates":"33e6399d","adsimages":"c92dbc7d","transactionalreport":"f4dea6fd","agentcommission":"24c19463","cards":"cb28d5a9","cashin":"7685de2e","cashinreport":"afd58bca","cashout":"d6c862c4","cashoutreport":"a6dc8c8a","commission_payments":"d6f02a97","dashboard~playerdetails":"27df054e","playerdetails":"f4da8331","dashboard~playerlist~playerlistduplicates~specialcommissions~summary_report":"a8818d96","dashboard":"d4ac7171","playerlist":"4ce1f7d6","specialcommissions":"82d6ef17","endingbets":"ac75d755","endingcards":"b2c79e13","endinggamedetails~endingscheduledgames":"b2afd7a9","endinggamedetails":"a303baa8","endingscheduledgames":"19d9c1c5","endinggamereport~endingprogressreport~luckyFourGameReport":"50cf1aa2","endinggamereport":"268865f0","endingprogressreport":"eca3ded6","luckyFourGameReport":"915f486d","investors":"b13fb589","leaguesbet":"fc16c528","luckyFourBets":"73678b50","luckyFourGames":"61ffe034","newPlayerList":"75177451","player_withdrawal_accounts":"509d3c18","players":"1409dd96","powerBallBets":"0467b09a","powerBallScheduledGames":"b820bed2","registeredplayerlist":"518df5c0","top_winning_combination":"017c008b","users":"bb690a78","adminAccess":"3dc19853","newsAndUpdates":"e7e92e58","cardspergame":"e75c19b7","playerlistduplicates":"772ce779","summary_report":"d5bd4257","endingconfig":"a57fe6ea","endingleagues":"9c97c539","endingteams":"cffd399a","luckyFourGameDetails":"a1e9d960","luckyFourPrizesSettings":"93fe0b4b","master_agents_token":"472d8989","playerRejectReasons":"69e68495","powerBallGameDetails":"3acf9b2b","sms":"8e28fba4","endingcarddetails":"410abb9d","login_verification":"5e6b4e61","pagenotfound":"34272697"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activePlayerList~adminAccess~adsimages~agentcommission~cards~cardspergame~cashin~cashinreport~cashou~51ae20eb":1,"activePlayerList~adsimages~agentcommission~cards~cashin~cashinreport~cashout~cashoutreport~commissio~7cf5bb2f":1,"activePlayerList":1,"adsimages~newsAndUpdates":1,"cards":1,"cashin":1,"cashinreport":1,"cashout":1,"cashoutreport":1,"commission_payments":1,"dashboard~playerdetails":1,"playerdetails":1,"dashboard~playerlist~playerlistduplicates~specialcommissions~summary_report":1,"dashboard":1,"specialcommissions":1,"endingbets":1,"endingcards":1,"endinggamedetails~endingscheduledgames":1,"endinggamedetails":1,"endinggamereport~endingprogressreport~luckyFourGameReport":1,"endinggamereport":1,"luckyFourGameReport":1,"investors":1,"leaguesbet":1,"luckyFourBets":1,"luckyFourGames":1,"newPlayerList":1,"player_withdrawal_accounts":1,"players":1,"powerBallBets":1,"powerBallScheduledGames":1,"registeredplayerlist":1,"top_winning_combination":1,"users":1,"adminAccess":1,"newsAndUpdates":1,"cardspergame":1,"endingconfig":1,"endingleagues":1,"endingteams":1,"luckyFourGameDetails":1,"luckyFourPrizesSettings":1,"master_agents_token":1,"playerRejectReasons":1,"powerBallGameDetails":1,"sms":1,"endingcarddetails":1,"login_verification":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activePlayerList~adminAccess~adsimages~agentcommission~cards~cardspergame~cashin~cashinreport~cashou~51ae20eb":"activePlayerList~adminAccess~adsimages~agentcommission~cards~cardspergame~cashin~cashinreport~cashou~51ae20eb","activePlayerList~adsimages~agentcommission~cards~cashin~cashinreport~cashout~cashoutreport~commissio~7cf5bb2f":"activePlayerList~adsimages~agentcommission~cards~cashin~cashinreport~cashout~cashoutreport~commissio~7cf5bb2f","activePlayerList":"activePlayerList","adsimages~endinggamereport~transactionalreport":"adsimages~endinggamereport~transactionalreport","adsimages~newsAndUpdates":"adsimages~newsAndUpdates","adsimages":"adsimages","transactionalreport":"transactionalreport","agentcommission":"agentcommission","cards":"cards","cashin":"cashin","cashinreport":"cashinreport","cashout":"cashout","cashoutreport":"cashoutreport","commission_payments":"commission_payments","dashboard~playerdetails":"dashboard~playerdetails","playerdetails":"playerdetails","dashboard~playerlist~playerlistduplicates~specialcommissions~summary_report":"dashboard~playerlist~playerlistduplicates~specialcommissions~summary_report","dashboard":"dashboard","playerlist":"playerlist","specialcommissions":"specialcommissions","endingbets":"endingbets","endingcards":"endingcards","endinggamedetails~endingscheduledgames":"endinggamedetails~endingscheduledgames","endinggamedetails":"endinggamedetails","endingscheduledgames":"endingscheduledgames","endinggamereport~endingprogressreport~luckyFourGameReport":"endinggamereport~endingprogressreport~luckyFourGameReport","endinggamereport":"endinggamereport","endingprogressreport":"endingprogressreport","luckyFourGameReport":"luckyFourGameReport","investors":"investors","leaguesbet":"leaguesbet","luckyFourBets":"luckyFourBets","luckyFourGames":"luckyFourGames","newPlayerList":"newPlayerList","player_withdrawal_accounts":"player_withdrawal_accounts","players":"players","powerBallBets":"powerBallBets","powerBallScheduledGames":"powerBallScheduledGames","registeredplayerlist":"registeredplayerlist","top_winning_combination":"top_winning_combination","users":"users","adminAccess":"adminAccess","newsAndUpdates":"newsAndUpdates","cardspergame":"cardspergame","playerlistduplicates":"playerlistduplicates","summary_report":"summary_report","endingconfig":"endingconfig","endingleagues":"endingleagues","endingteams":"endingteams","luckyFourGameDetails":"luckyFourGameDetails","luckyFourPrizesSettings":"luckyFourPrizesSettings","master_agents_token":"master_agents_token","playerRejectReasons":"playerRejectReasons","powerBallGameDetails":"powerBallGameDetails","sms":"sms","endingcarddetails":"endingcarddetails","login_verification":"login_verification","pagenotfound":"pagenotfound"}[chunkId]||chunkId) + "." + {"activePlayerList~adminAccess~adsimages~agentcommission~cards~cardspergame~cashin~cashinreport~cashou~51ae20eb":"50c2b9da","activePlayerList~adsimages~agentcommission~cards~cashin~cashinreport~cashout~cashoutreport~commissio~7cf5bb2f":"2090ba31","activePlayerList":"4eb0deb2","adsimages~endinggamereport~transactionalreport":"31d6cfe0","adsimages~newsAndUpdates":"b2b8af2f","adsimages":"31d6cfe0","transactionalreport":"31d6cfe0","agentcommission":"31d6cfe0","cards":"4eb0deb2","cashin":"0a807138","cashinreport":"4eb0deb2","cashout":"0a807138","cashoutreport":"4eb0deb2","commission_payments":"4eb0deb2","dashboard~playerdetails":"27764690","playerdetails":"09f65b4a","dashboard~playerlist~playerlistduplicates~specialcommissions~summary_report":"4eb0deb2","dashboard":"39ee43f1","playerlist":"31d6cfe0","specialcommissions":"8dc5784a","endingbets":"4eb0deb2","endingcards":"4eb0deb2","endinggamedetails~endingscheduledgames":"f8cf5bd3","endinggamedetails":"209566b3","endingscheduledgames":"31d6cfe0","endinggamereport~endingprogressreport~luckyFourGameReport":"17e3c51b","endinggamereport":"49830f27","endingprogressreport":"31d6cfe0","luckyFourGameReport":"49830f27","investors":"1580acf5","leaguesbet":"4eb0deb2","luckyFourBets":"4eb0deb2","luckyFourGames":"a1374912","newPlayerList":"4eb0deb2","player_withdrawal_accounts":"9dd25db9","players":"4eb0deb2","powerBallBets":"4eb0deb2","powerBallScheduledGames":"50af6957","registeredplayerlist":"4eb0deb2","top_winning_combination":"4eb0deb2","users":"0bc8a53d","adminAccess":"a1374912","newsAndUpdates":"8dc5784a","cardspergame":"4eb0deb2","playerlistduplicates":"31d6cfe0","summary_report":"31d6cfe0","endingconfig":"4eb0deb2","endingleagues":"2d3c8552","endingteams":"061002c4","luckyFourGameDetails":"65f161fe","luckyFourPrizesSettings":"4eb0deb2","master_agents_token":"49830f27","playerRejectReasons":"98b5ab28","powerBallGameDetails":"65f161fe","sms":"1964f093","endingcarddetails":"0953f63d","login_verification":"747c3712","pagenotfound":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
